import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

import { useParams } from 'react-router-dom';
import React, { useState, useEffect } from "react";

import HeaderExtra from '../components/HeaderExtra.jsx'
import FooterExtraPage from '../components/FooterExtraPage'

import  '../Assets/js/generalui.js'
import  '../Assets/js/extrapage.js'
import  '../Assets/css/extrapage.css'

window.Swiper = Swiper;
window.Navigation = Navigation;
window.Pagination = Pagination;

function Home()
{
  const { lang } = useParams();

  useEffect(() =>
  {
    window.PrepareBasicElement(lang);
    window.PrepareServicePageElements();
  }, [lang]);

  // Append Body Element To 'root' -----------------------------------------------------
  return(
    <div className="basic">
      <HeaderExtra/>
      <div className="MainContentSection MainSectionWithoutAnyAdd" style={{flexDirection: "column"}}>
        {/* Section 1 ------------------------------------ */}
        <div className="SectionParentContainer ServiceSection1Con PlayableOnScroll">
          <div className="SectionMainChildContainer">
            <div className="ServicePinginGoSection1Text RowGapBasic" style={{display:"flex", flexDirection:"column"}}>
              <div className="TopTextContainerSe">
                <p className="BigSizeText SpecialBigSizeLineHeight PoppinsExBoldTextFont ElementToAnimateTyping" style={{color:"#1D76AE"}} id='Section1Header1Text'>Kelola OTA <span className="SmallTextPadding BasicRadius" style={{whiteSpace:"nowrap", backgroundColor:"#ED7C42", color:"white"}}>#Tanpa Ribet</span></p>
                <p className="BigSizeText SpecialBigSizeLineHeight PoppinsExBoldTextFont ElementToAnimateTyping" style={{color:"#1D76AE"}} id='Section1Header2Text'>Booking Tetap Jalan.</p>
              </div>

              <p className="SpecialMidSizeText3 PoppinsRegularTextFont" style={{color:"#667085"}} id='Section1MessageText'>PinginGo membantu penginapan nature & experience stay mengelola OTA secara rapi, konsisten, dan profesional tanpa membebani operasional harian Anda.</p>
              <div className="ButtonGapContainer" style={{display:'flex'}}>
                <button className='BigUIButton BasicRadius OrangeButton ElementToAnimateGrowOpacity Selectable'>
                  <p className='InterMediumTextFont' id='Section1Button1Text'>Free 15-Minute Property Audit</p>
                </button>
                <button className='BigUIButton BasicRadius OrangeLineButton ElementToAnimateGrowOpacity Selectable'>
                  <p className='InterMediumTextFont' id='Section1Button2Text'>Download Our Proposal</p>
                </button>
              </div>
            </div>
            <img className="ServicePinginGoImage1" src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/ServicePageAssets/Munduk_Villa_50 1.jpg"}/>
          </div>
        </div>

        {/* Section 2 ------------------------------------ */}
        <div className="SectionParentContainer ServiceSection2Con PlayableOnScroll">
          <div className="SectionMainChildContainer ThisWipeAnimation" style={{backgroundColor:"#F5FBFF", overflow:"hidden"}}>
            <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/small-batik-bg.svg"} className="BatikSquareTopLeft" />
            <img src={process.env.PUBLIC_URL + "/Assets/images/LogoIcon.svg"} className="PinginGoIconRightExtra" />
            <div className="ServicePinginGoSection2EarlyWrapper">
              <div className="TypingTextAnimContainer">
                <p className="BigSizeText SpecialBigSizeLineHeight PoppinsExBoldTextFont ElementToAnimateTyping" id='SiapaSection2Text' style={{color:"#1D76AE"}}>Siapa</p>
              </div>
              <p className="BiggestSizeText PoppinsBoldTextFont" id='PinginGoSection2Text' style={{color:"#ED7C42"}}>PinginGo</p>
              <div className="RowGapBasic" style={{display:"flex", flexDirection:"column"}}>
                <p className="SpecialMidSizeText3 PoppinsBoldTextFont MessageSec2ServiceText1" id='Section2Message1' style={{color:"#000000", textAlign:"center"}}>PinginGo adalah platform perjalanan berbasis alam dan pengalaman yang menggabungkan aplikasi booking terkurasi dengan layanan manajemen OTA profesional untuk membantu penginapan unik bertumbuh secara berkelanjutan.</p>
                <p className="SpecialMidSizeText3 PoppinsRegularTextFont MessageSec2ServiceText2" id='Section2Message2' style={{color:"#000000", textAlign:"center"}}>Melalui aplikasi PinginGo, kami menghubungkan wisatawan dengan penginapan dan pengalaman terkurasi di seluruh Indonesia. Kami juga mendukung pemilik akomodasi melalui layanan setup dan manajemen OTA profesional membantu penginapan untuk listing, optimasi, dan pengelolaan di berbagai kanal OTA utama.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Section 3 ------------------------------------ */}
        <div className="SectionParentContainer ServiceSection3Con PlayableOnScroll">
          <div className="SectionMainChildContainer section3ParentContainer" style={{overflow:"hidden"}}>

            <div className="ServicePinginGoSection3Text RowGapBasic" style={{display:"flex", flexDirection:"column"}}>
              <p className="BigSizeText SpecialBigSizeLineHeight PoppinsExBoldTextFont" id='Section3HeaderText' style={{color:"#1D76AE"}}>Masalah yang Sering Dialami Penginapan</p>
              <div className="ColumnGapBasic" style={{display:"flex"}}>
                  <div className="OrangePaddingExtraPage">
                    <img src={process.env.PUBLIC_URL + "/Assets/images/Icon/clock-grey.svg"} className="MidSizeIcon"/>
                  </div>
                  <p className="SpecialMidSizeText3 PoppinsRegularTextFont" id='Section3MasalahText1' style={{color:"#667085"}}>Ribet dan Memakan Waktu</p>
              </div>
              <div className="ColumnGapBasic" style={{display:"flex"}}>
                  <div className="OrangePaddingExtraPage">
                    <img src={process.env.PUBLIC_URL + "/Assets/images/Icon/dollar-sign-grey.svg"} className="MidSizeIcon"/>
                  </div>
                  <p className="SpecialMidSizeText3 PoppinsRegularTextFont" id='Section3MasalahText2' style={{color:"#667085"}}>Transparansi harga yang didapat</p>
              </div>
              <div className="ColumnGapBasic" style={{display:"flex"}}>
                  <div className="OrangePaddingExtraPage">
                    <img src={process.env.PUBLIC_URL + "/Assets/images/Icon/calendar-x-grey.svg"} className="MidSizeIcon"/>
                  </div>
                  <p className="SpecialMidSizeText3 PoppinsRegularTextFont" id='Section3MasalahText3' style={{color:"#667085"}}>Sudah Listing, tapi Sepi Booking</p>
              </div>
              <div className="ColumnGapBasic" style={{display:"flex"}}>
                  <div className="OrangePaddingExtraPage">
                    <img src={process.env.PUBLIC_URL + "/Assets/images/Icon/book-grey.svg"} className="MidSizeIcon"/>
                  </div>
                  <p className="SpecialMidSizeText3 PoppinsRegularTextFont" id='Section3MasalahText4' style={{color:"#667085"}}>Kurang Paham Setup OTA</p>
              </div>
              <div className="ColumnGapBasic" style={{display:"flex"}}>
                  <div className="OrangePaddingExtraPage">
                    <img src={process.env.PUBLIC_URL + "/Assets/images/Icon/muscle-grey.svg"} className="MidSizeIcon"/>
                  </div>
                  <p className="SpecialMidSizeText3 PoppinsRegularTextFont" id='Section3MasalahText5' style={{color:"#667085"}}>Tidak Memiliki Manpower Khusus</p>
              </div>
              <div className="ColumnGapBasic" style={{display:"flex"}}>
                  <div className="OrangePaddingExtraPage">
                    <img src={process.env.PUBLIC_URL + "/Assets/images/Icon/price-tag-grey.svg"} className="MidSizeIcon"/>
                  </div>
                  <p className="SpecialMidSizeText3 PoppinsRegularTextFont" id='Section3MasalahText6' style={{color:"#667085"}}>Mindset Harga Dikontrol OTA</p>
              </div>
              <div className="ColumnGapBasic" style={{display:"flex"}}>
                  <div className="OrangePaddingExtraPage">
                    <img src={process.env.PUBLIC_URL + "/Assets/images/Icon/eye-grey.svg"} className="MidSizeIcon"/>
                  </div>
                  <p className="SpecialMidSizeText3 PoppinsRegularTextFont" id='Section3MasalahText7' style={{color:"#667085"}}>Kurangnya Awareness & Visibilitas</p>
              </div>
              <div className="ColumnGapBasic" style={{display:"flex"}}>
                  <div className="OrangePaddingExtraPage">
                    <img src={process.env.PUBLIC_URL + "/Assets/images/Icon/money-bag-grey.svg"} className="MidSizeIcon"/>
                  </div>
                  <p className="SpecialMidSizeText3 PoppinsRegularTextFont" id='Section3MasalahText8' style={{color:"#667085"}}>Komisi OTA yang Tinggi</p>
              </div>
            </div>

            <div className="ServicePinginGoSection3ImageWrapper">
              <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/ServicePageAssets/Munduk_Back.jpg"} className="MundukBGExperience"/>
              <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/ServicePageAssets/man_look_watch.png"} className="ManLookWatchExperience"/>
            </div>

          </div>
        </div>

        {/* Section 4 ------------------------------------ */}
        <div className="SectionParentContainer ServiceSection4Con PlayableOnScroll">
          <div className="SectionMainChildContainer section4ParentContainer" style={{overflow:"hidden", flexDirection:"column"}}>

            <div className="ServicePinginGoSection4MainWrapper">

              <div className="ColumnGapBasic2" style={{display:"flex", height:"fit-content"}}>
                <p className="BigSizeText PoppinsExBoldTextFont" id='Section4HeaderText' style={{color:"#1D76AE"}}>Solusi dari</p>
                <img className="PinginGoLogoBig Selectable2" src={process.env.PUBLIC_URL + "/Assets/images/Icon/pingingo-icon.svg"}/>
              </div>

              <div className="AturAkomodasiStepPreviewWrapper SolusiExtraPageMainWrapper">

                <div className="SolusiPreviewImageWrapperExtraPage">
                  <div className="AturAkomodasiStepPreviewContainer ThisSelected" name="SolusiImagePreview">
                    <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/ServicePageAssets/Solusi1.jpg"} className="AturAkomodasiStepPreview ServiceSolusiImg1"/>
                  </div>
                  <div className="AturAkomodasiStepPreviewContainer" style={{opacity:0, left:"-20%", position:"absolute"}} name="SolusiImagePreview">
                    <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/ServicePageAssets/Solusi2.jpg"} className="AturAkomodasiStepPreview ServiceSolusiImg2"/>
                  </div>
                  <div className="AturAkomodasiStepPreviewContainer" style={{opacity:0, left:"-20%", position:"absolute"}} name="SolusiImagePreview">
                    <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/ServicePageAssets/Solusi3.jpg"} className="AturAkomodasiStepPreview ServiceSolusiImg3"/>
                  </div>
                  <div className="AturAkomodasiStepPreviewContainer" style={{opacity:0, left:"-20%", position:"absolute"}} name="SolusiImagePreview">
                    <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/ServicePageAssets/Solusi4.jpg"} className="AturAkomodasiStepPreview ServiceSolusiImg4"/>
                  </div>
                  <div className="AturAkomodasiStepPreviewContainer" style={{opacity:0, left:"-20%", position:"absolute"}} name="SolusiImagePreview">
                    <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/ServicePageAssets/Solusi5.jpg"} className="AturAkomodasiStepPreview ServiceSolusiImg5"/>
                  </div>
                  <div className="AturAkomodasiStepPreviewContainer" style={{opacity:0, left:"-20%", position:"absolute"}} name="SolusiImagePreview">
                    <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/ServicePageAssets/Solusi6.jpg"} className="AturAkomodasiStepPreview ServiceSolusiImg6"/>
                  </div>
                  <div className="AturAkomodasiStepPreviewContainer" style={{opacity:0, left:"-20%", position:"absolute"}} name="SolusiImagePreview">
                    <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/ServicePageAssets/Solusi7.jpg"} className="AturAkomodasiStepPreview ServiceSolusiImg7"/>
                  </div>
                </div>

                <div className="SolusiPingingoStepWrapper">
                  <div className="AturAkomodasiCheckBoxWrapper">
                    <input className="AturAkomodasiCheckBoxClickable" type="radio" name="SolusiRadioButton" id="AturAkomodasiCheck1" onChange={()=>window.OnRadioButtonClicked("SolusiRadioButton", "SolusiImagePreview", "left")} />
                    <label className="AturAkomodasiStepPanel BasicRadius Selectable2" htmlFor="AturAkomodasiCheck1">
                      <img className="AturAkomodasiCheckBox"/>
                      <div className="CheckBoxTextContainer">
                        <p className="CheckBoxText InterBoldTextFont" id='Section4Solusi1HeaderText'>Setup & Aktivasi OTA</p>
                        <div className="CollapsibleTextBoxAtur">
                          <p className="CheckBoxAturDescription InterRegularTextFont" id='Section4Solusi1MessageText'>Pembuatan dan pengaturan akun OTA hingga properti siap menerima booking.</p>
                        </div>
                      </div>
                    </label>
                    <input type="radio" name="SolusiRadioButton" id="AturAkomodasiCheck2" className="AturAkomodasiCheckBoxClickable"  onChange={()=>window.OnRadioButtonClicked("SolusiRadioButton", "SolusiImagePreview", "left")} />
                    <label className="AturAkomodasiStepPanel BasicRadius Selectable2" htmlFor="AturAkomodasiCheck2">
                      <img className="AturAkomodasiCheckBox"/>
                      <div className="CheckBoxTextContainer">
                        <p className="CheckBoxText InterBoldTextFont" id='Section4Solusi2HeaderText'>Optimasi Listing</p>
                        <div className="CollapsibleTextBoxAtur">
                          <p className="CheckBoxAturDescription InterRegularTextFont" id='Section4Solusi2MessageText'>Judul, deskripsi, dan highlight berbasis storytelling agar listing lebih menarik dan mudah ditemukan.</p>
                        </div>
                      </div>
                    </label>
                    <input type="radio" name="SolusiRadioButton" id="AturAkomodasiCheck3" className="AturAkomodasiCheckBoxClickable" onChange={()=>window.OnRadioButtonClicked("SolusiRadioButton", "SolusiImagePreview", "left")} />
                    <label className="AturAkomodasiStepPanel BasicRadius Selectable2" htmlFor="AturAkomodasiCheck3">
                      <img className="AturAkomodasiCheckBox"/>
                      <div className="CheckBoxTextContainer">
                        <p className="CheckBoxText InterBoldTextFont" id='Section4Solusi3HeaderText'>Penataan Visual & Konten</p>
                        <div className="CollapsibleTextBoxAtur">
                          <p className="CheckBoxAturDescription InterRegularTextFont" id='Section4Solusi3MessageText'>Judul, deskripsi, dan highlight berbasis storytelling agar listing lebih menarik dan mudah ditemukan.</p>
                        </div>
                      </div>
                    </label>
                    <input type="radio" name="SolusiRadioButton" id="AturAkomodasiCheck4" className="AturAkomodasiCheckBoxClickable" onChange={()=>window.OnRadioButtonClicked("SolusiRadioButton", "SolusiImagePreview", "left")} />
                    <label className="AturAkomodasiStepPanel BasicRadius Selectable2" htmlFor="AturAkomodasiCheck4">
                      <img className="AturAkomodasiCheckBox"/>
                      <div className="CheckBoxTextContainer">
                        <p className="CheckBoxText InterBoldTextFont" id='Section4Solusi4HeaderText'>Strategi Harga</p>
                        <div className="CollapsibleTextBoxAtur">
                          <p className="CheckBoxAturDescription InterRegularTextFont" id='Section4Solusi4MessageText'>Penentuan harga yang sehat berdasarkan hari, musim, dan demand tanpa banting harga.</p>
                        </div>
                      </div>
                    </label>
                    <input type="radio" name="SolusiRadioButton" id="AturAkomodasiCheck5" className="AturAkomodasiCheckBoxClickable" onChange={()=>window.OnRadioButtonClicked("SolusiRadioButton", "SolusiImagePreview", "left")} />
                    <label className="AturAkomodasiStepPanel BasicRadius Selectable2" htmlFor="AturAkomodasiCheck5">
                      <img className="AturAkomodasiCheckBox"/>
                      <div className="CheckBoxTextContainer">
                        <p className="CheckBoxText InterBoldTextFont" id='Section4Solusi5HeaderText'>Manajemen Kalender & Ketersediaan</p>
                        <div className="CollapsibleTextBoxAtur">
                          <p className="CheckBoxAturDescription InterRegularTextFont" id='Section4Solusi5MessageText'>Sinkronisasi kalender untuk mencegah overbooking dan kesalahan tanggal.</p>
                        </div>
                      </div>
                    </label>
                    <input type="radio" name="SolusiRadioButton" id="AturAkomodasiCheck6" className="AturAkomodasiCheckBoxClickable" onChange={()=>window.OnRadioButtonClicked("SolusiRadioButton", "SolusiImagePreview", "left")} />
                    <label className="AturAkomodasiStepPanel BasicRadius Selectable2" htmlFor="AturAkomodasiCheck6">
                      <img className="AturAkomodasiCheckBox"/>
                      <div className="CheckBoxTextContainer">
                        <p className="CheckBoxText InterBoldTextFont" id='Section4Solusi6HeaderText'>Monitoring & Optimasi Berkala</p>
                        <div className="CollapsibleTextBoxAtur">
                          <p className="CheckBoxAturDescription InterRegularTextFont" id='Section4Solusi6MessageText'>Monitoring performa listing dan penyesuaian berkala untuk hasil yang lebih stabil.</p>
                        </div>
                      </div>
                    </label>
                    <input type="radio" name="SolusiRadioButton" id="AturAkomodasiCheck7" className="AturAkomodasiCheckBoxClickable" onChange={()=>window.OnRadioButtonClicked("SolusiRadioButton", "SolusiImagePreview", "left")} />
                    <label className="AturAkomodasiStepPanel BasicRadius Selectable2" htmlFor="AturAkomodasiCheck7">
                      <img className="AturAkomodasiCheckBox"/>
                      <div className="CheckBoxTextContainer">
                        <p className="CheckBoxText InterBoldTextFont" id='Section4Solusi7HeaderText'>Express Website untuk Properti anda</p>
                        <div className="CollapsibleTextBoxAtur">
                          <p className="CheckBoxAturDescription InterRegularTextFont" id='Section4Solusi7MessageText'>Monitoring performa listing dan penyesuaian berkala untuk hasil yang lebih stabil.</p>
                        </div>
                      </div>
                    </label>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>

        {/* Section 5 ------------------------------------ */}
        <div className="SectionParentContainer ServiceSection5Con PlayableOnScroll">
          <div className="SectionMainChildContainer section5ParentContainer" style={{overflow:"hidden", flexDirection:"column", backgroundColor:"#F6F8FC"}}>

            <div className="ServicePinginGoSection4MainWrapper">

              <div className="ColumnGapBasic2" style={{display:"flex", height:"fit-content"}}>
                <p className="BigSizeText PoppinsExBoldTextFont" id='Section5HeaderText' style={{color:"#1D76AE"}}>Kenapa Memilih <span style={{color:"#ED7C42"}}>PinginGo?</span></p>
              </div>
              <div className="SwiperExtraPageMainWrapper">
                <div className="SwiperExtraPagecontainer">
                  <div className="swiper-wrapper">
                    <div className="swiper-slide SwiperExtraPageSwiper ExtraPageSwiper1">
                      <div className="ExtraPageSwiperContentWrapper">
                        <div className="ServiceWhySwiperTextWrapper RowGapBasic">
                          <p className="BigSizeText PoppinsBoldTextFont" id='Section5ReasonHeader1Text' style={{color:"#FFFFFF"}}>Spesialis Penginapan Nature & Experience</p>
                          <p className="MidSizeText InterRegularTextFont" id='Section5ReasonMessage1Text' style={{color:"#FFFFFF"}}>Kami paham cara menjual penginapan unik villa, glamping, eco-lodge, dan boutique stay tanpa menjadikannya hotel massal.</p>
                        </div>
                      </div>
                      <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/ServicePageAssets/WhyJoinImage/slide1.png"} className="WhySwiperImage"/>
                    </div>
                    <div className="swiper-slide SwiperExtraPageSwiper ExtraPageSwiper1">
                      <div className="ExtraPageSwiperContentWrapper">
                        <div className="ServiceWhySwiperTextWrapper RowGapBasic">
                          <p className="BigSizeText PoppinsBoldTextFont" id='Section5ReasonHeader2Text' style={{color:"#FFFFFF"}}>Menjual Nilai, Bukan Diskon</p>
                          <p className="MidSizeText InterRegularTextFont" id='Section5ReasonMessage2Text' style={{color:"#FFFFFF"}}>Pendekatan kami berbasis storytelling, positioning, dan pengalaman, sehingga booking tidak bergantung pada diskon terus-menerus.</p>
                        </div>
                      </div>
                      <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/ServicePageAssets/WhyJoinImage/slide2.png"} className="WhySwiperImage"/>
                    </div>
                    <div className="swiper-slide SwiperExtraPageSwiper ExtraPageSwiper1">
                      <div className="ExtraPageSwiperContentWrapper">
                        <div className="ServiceWhySwiperTextWrapper RowGapBasic">
                          <p className="BigSizeText PoppinsBoldTextFont" id='Section5ReasonHeader3Text' style={{color:"#FFFFFF"}}>Lebih dari Sekadar Admin OTA</p>
                          <p className="MidSizeText InterRegularTextFont" id='Section5ReasonMessage3Text' style={{color:"#FFFFFF"}}>Kami tidak hanya mengunggah kamar, tetapi merancang listing yang menarik tamu yang tepat dan meningkatkan konversi.</p>
                        </div>
                      </div>
                      <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/ServicePageAssets/WhyJoinImage/slide3.png"} className="WhySwiperImage"/>
                    </div>
                    <div className="swiper-slide SwiperExtraPageSwiper ExtraPageSwiper1">
                      <div className="ExtraPageSwiperContentWrapper">
                        <div className="ServiceWhySwiperTextWrapper RowGapBasic">
                          <p className="BigSizeText PoppinsBoldTextFont" id='Section5ReasonHeader4Text' style={{color:"#FFFFFF"}}>Berpihak pada Owner & Transparan</p>
                          <p className="MidSizeText InterRegularTextFont" id='Section5ReasonMessage4Text' style={{color:"#FFFFFF"}}>Akun, data, dan keputusan harga tetap sepenuhnya milik pemilik penginapan. Tanpa lock-in, tanpa kontrol tersembunyi.</p>
                        </div>
                      </div>
                      <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/ServicePageAssets/WhyJoinImage/slide4.png"} className="WhySwiperImage"/>
                    </div>
                    <div className="swiper-slide SwiperExtraPageSwiper ExtraPageSwiper1">
                      <div className="ExtraPageSwiperContentWrapper">
                        <div className="ServiceWhySwiperTextWrapper RowGapBasic">
                          <p className="BigSizeText PoppinsBoldTextFont" id='Section5ReasonHeader5Text' style={{color:"#FFFFFF"}}>Lebih Tenang, Lebih Terkontrol</p>
                          <p className="MidSizeText InterRegularTextFont" id='Section5ReasonMessage5Text' style={{color:"#FFFFFF"}}>Dari sinkronisasi kalender hingga monitoring rutin, kami meminimalkan kesalahan, risiko overbooking, dan kerumitan operasional.</p>
                        </div>
                      </div>
                      <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/ServicePageAssets/WhyJoinImage/slide5.png"} className="WhySwiperImage"/>
                    </div>
                    <div className="swiper-slide SwiperExtraPageSwiper ExtraPageSwiper1">
                      <div className="ExtraPageSwiperContentWrapper">
                        <div className="ServiceWhySwiperTextWrapper RowGapBasic">
                          <p className="BigSizeText PoppinsBoldTextFont" id='Section5ReasonHeader6Text' style={{color:"#FFFFFF"}}>Didukung Ekosistem PinginGo</p>
                          <p className="MidSizeText InterRegularTextFont" id='Section5ReasonMessage6Text' style={{color:"#FFFFFF"}}>Selain manajemen OTA, penginapan Anda mendapat exposure dari platform travel PinginGo yang berfokus pada nature, insight pasar, dan dukungan konten.</p>
                        </div>
                      </div>
                      <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/ServicePageAssets/WhyJoinImage/slide6.png"} className="WhySwiperImage"/>
                    </div>
                  </div>
                </div>
                <div className="ExtraPageNextPrevButton">
                  <img src={process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/next-button-navigation.svg"} className="SwiperNextPrevButton PrevButton Selectable2"/>
                  <img src={process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/next-button-navigation.svg"} className="SwiperNextPrevButton NextButton Selectable2"/>
                </div>
                <div className="swiper-pagination OrangeSwiperPagination swiper-pagination-clickable swiper-pagination-bullets">
                  {/* <span className="swiper-pagination-bullet swiper-pagination-bullet-active" tabIndex="0" role="button" aria-label="Go to slide 1"></span>
                  <span className="swiper-pagination-bullet" tabIndex="0" role="button" aria-label="Go to slide 2"></span>
                  <span className="swiper-pagination-bullet" tabIndex="0" role="button" aria-label="Go to slide 3"></span>
                  <span className="swiper-pagination-bullet" tabIndex="0" role="button" aria-label="Go to slide 4"></span> */}
                  </div>
              </div>
            </div>

          </div>
        </div>

        {/* Section 6 ------------------------------------ */}
        <div className="SectionParentContainer ServiceSection6Con PlayableOnScroll">
          <div className="SectionMainChildContainer section5ParentContainer BlueBasicGradient ThisWipeAnimation2" style={{overflow:"hidden", flexDirection:"column"}}>
            <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/circle-edge-blue2.svg"} className="BlueCircleEdgeExtraPage2"/>
            <div className="ServicePinginGoSection4MainWrapper RowGapBasic">
              <p className="BigSizeText PoppinsExBoldTextFont" id='Section6HeaderText' style={{color:"white", margin:"0 auto"}}>Alur Kerja yang Terstruktur</p>
              
              <div className="ExpandingCircleOrangeContainer">
                <div className="ExpandingCircleOrange" />
                <div className="ExpandingCircleOrangeAnimate"/>
              </div>

              <div className="ExtraPageStepSectionMainContainer">
                <div className="ExtraPageStepSectionWrapper">
                  <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/daftar-step1.svg"} className="ExtraPageStepSectionIcon"/>
                  <p className="InterBoldTextFont MidSizeText" id='AlurHeaderText1' style={{textAlign:"center", margin:"0 auto"}}>Audit & Onboarding</p>
                  <p className="InterRegularTextFont MidSizeText2" id='AlurMessageText1' style={{ color: "#667085", textAlign:"center", margin:"0 auto"}}>Kami meninjau penginapan dan mengumpulkan seluruh aset yang dibutuhkan.</p>
                </div>
                <div className="ExtraPageStepSectionWrapper">
                  <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/daftar-step2.svg"} className="ExtraPageStepSectionIcon"/>
                  <p className="InterBoldTextFont MidSizeText" id='AlurHeaderText2' style={{textAlign:"center", margin:"0 auto"}}>Setup & Optimization</p>
                    <p className="InterRegularTextFont MidSizeText2" id='AlurMessageText2' style={{ color: "#667085", textAlign:"center", margin:"0 auto"}}>Kami menyiapkan akun OTA serta mengoptimalkan listing, konten, dan harga.</p>
                </div>
                <div className="ExtraPageStepSectionWrapper">
                  <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/daftar-step3.svg"} className="ExtraPageStepSectionIcon"/>
                  <p className="InterBoldTextFont MidSizeText" id='AlurHeaderText3' style={{textAlign:"center", margin:"0 auto"}}>Go Live</p>
                  <p className="InterRegularTextFont MidSizeText2" id='AlurMessageText3' style={{ color: "#667085", textAlign:"center", margin:"0 auto"}}>Penginapan tayang dan siap menerima booking.</p>
                </div>
                <div className="ExtraPageStepSectionWrapper">
                  <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/daftar-step4.svg"} className="ExtraPageStepSectionIcon"/>
                  <p className="InterBoldTextFont MidSizeText" id='AlurHeaderText4' style={{textAlign:"center", margin:"0 auto"}}>Monitor & Improve</p>
                  <p className="InterRegularTextFont MidSizeText2" id='AlurMessageText4' style={{ color: "#667085", textAlign:"center", margin:"0 auto"}}>Performa dipantau dan dioptimalkan secara berkala.</p>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* Section 7 ------------------------------------ */}
        <div className="SectionParentContainer ServiceSection7Con PlayableOnScroll" style={{backgroundColor:"#F6F8FC"}}>
          <div className="SectionMainChildContainer section7ParentContainer" style={{overflow:"hidden", flexDirection:"column"}}>

            <div className="ServicePinginGoSection7MainWrapper RowGapBasic">

              <div className="ColumnGapBasic2 Section7HeaderText" style={{display:"flex", height:"fit-content", marginLeft: 0}}>
                <p className="BigSizeText PoppinsBoldTextFont" id='Section7HeaderText' style={{color:"#1D76AE"}}>Hasil yang<br/><span className="BiggerSizeText PoppinsBoldTextFont" style={{color:"#ED7C42"}}>Diharapkan</span></p>
              </div>

              <div className="RowGapBasic" style={{display:"flex", flexDirection:"column"}}>
                <div className="ColumnGapBasic2 HasilDiharapkanService" style={{display:"flex"}}>
                  <div className="OrangePaddingExtraPage">
                    <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/ServicePageAssets/HasilDiharapkanIcon/rocket-orange.svg"} className="BigSizeIcon"/>
                  </div>
                  <div className="RowGapBasic">
                    <p className="SpecialMidSizeText3 PoppinsExBoldTextFont" id='Section7MessageText1' style={{color:"#000000"}}>Listing Profesional & Siap Konversi</p>
                    <p className="SpecialMidSizeText3 PoppinsRegularTextFont" id='Section7MessageText2' style={{color:"#475467"}}>Penginapan tampil rapi, konsisten, dan menarik di OTA memudahkan calon tamu memahami value penginapan dan melakukan booking.</p>
                  </div>
                </div>

                <div className="ColumnGapBasic2 HasilDiharapkanService" style={{display:"flex"}}>
                  <div className="OrangePaddingExtraPage">
                    <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/ServicePageAssets/HasilDiharapkanIcon/insight-orange.svg"} className="BigSizeIcon"/>
                  </div>
                  <div className="RowGapBasic">
                    <p className="SpecialMidSizeText3 PoppinsExBoldTextFont" id='HasilDiharapkanHeaderText1' style={{color:"#000000"}}>Positioning Kuat Tanpa Perang Harga</p>
                    <p className="SpecialMidSizeText3 PoppinsRegularTextFont" id='HasilDiharapkanMessageText1' style={{color:"#475467"}}>Kami menonjolkan pengalaman dan karakter penginapan, sehingga Anda tidak bergantung pada diskon terus-menerus untuk bersaing.</p>
                  </div>
                </div>

                <div className="ColumnGapBasic2 HasilDiharapkanService" style={{display:"flex"}}>
                  <div className="OrangePaddingExtraPage">
                    <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/ServicePageAssets/HasilDiharapkanIcon/scan-orange.svg"} className="BigSizeIcon"/>
                  </div>
                  <div className="RowGapBasic">
                    <p className="SpecialMidSizeText3 PoppinsExBoldTextFont" id='HasilDiharapkanHeaderText2' style={{color:"#000000"}}>Visibilitas Lebih Baik di OTA</p>
                    <p className="SpecialMidSizeText3 PoppinsRegularTextFont" id='HasilDiharapkanMessageText2' style={{color:"#475467"}}>Struktur listing, konten, dan kategori yang tepat membantu penginapan lebih mudah muncul di pencarian yang relevan.</p>
                  </div>
                </div>

                <div className="ColumnGapBasic2 HasilDiharapkanService" style={{display:"flex"}}>
                  <div className="OrangePaddingExtraPage">
                    <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/ServicePageAssets/HasilDiharapkanIcon/calendar-orange.svg"} className="BigSizeIcon"/>
                  </div>
                  <div className="RowGapBasic">
                    <p className="SpecialMidSizeText3 PoppinsExBoldTextFont" id='HasilDiharapkanHeaderText3' style={{color:"#000000"}}>Kontrol Harga & Ketersediaan Lebih Sehat</p>
                    <p className="SpecialMidSizeText3 PoppinsRegularTextFont" id='HasilDiharapkanMessageText3' style={{color:"#475467"}}>Strategi harga weekday, weekend, dan seasonal lebih terarah, dengan kalender tersinkron untuk meminimalkan risiko overbooking.</p>
                  </div>
                </div>

                <div className="ColumnGapBasic2 HasilDiharapkanService" style={{display:"flex"}}>
                  <div className="OrangePaddingExtraPage">
                    <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/ServicePageAssets/HasilDiharapkanIcon/task-orange.svg"} className="BigSizeIcon"/>
                  </div>
                  <div className="RowGapBasic">
                    <p className="SpecialMidSizeText3 PoppinsExBoldTextFont" id='HasilDiharapkanHeaderText4' style={{color:"#000000"}}>Beban Operasional Lebih Ringan</p>
                    <p className="SpecialMidSizeText3 PoppinsRegularTextFont" id='HasilDiharapkanMessageText4' style={{color:"#475467"}}>Pekerjaan admin OTA berkurang, kesalahan manual diminimalkan, dan pengelolaan jadi lebih terstruktur.</p>
                  </div>
                </div>

                <div className="ColumnGapBasic2 HasilDiharapkanService" style={{display:"flex"}}>
                  <div className="OrangePaddingExtraPage">
                    <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/ServicePageAssets/HasilDiharapkanIcon/insight-orange.svg"} className="BigSizeIcon"/>
                  </div>
                  <div className="RowGapBasic">
                    <p className="SpecialMidSizeText3 PoppinsExBoldTextFont" id='HasilDiharapkanHeaderText5' style={{color:"#000000"}}>Insight untuk Pengambilan Keputusan</p>
                    <p className="SpecialMidSizeText3 PoppinsRegularTextFont" id='HasilDiharapkanMessageText5' style={{color:"#475467"}}>Monitoring performa memberikan gambaran yang jelas terkait permintaan, harga, dan performa listing untuk keputusan yang lebih tepat.</p>
                  </div>
                </div>
              </div>

            </div>
            
            <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/ServicePageAssets/HasilDiharapkanIcon/Woman-phone-smile.png"} className="GirlPhoneSolusiPage" />
          </div>
        </div>

        {/* Section 8 ------------------------------------ */}
        <div className="SectionParentContainer ServiceSection8Con PlayableOnScroll" style={{backgroundColor:"#F6F8FC"}}>
          <div className="SectionMainChildContainer section8ParentContainer" style={{overflow:"hidden", flexDirection:"column"}}>
            <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/small-batik-bg.svg"} className="BatikSquareTopLeft"/>
            <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/small-batik-bg.svg"} className="BatikSquareBottomRight"/>
            <div className="ServicePinginGoSection8EarlyWrapper RowGapBasic" style={{display:"flex", flexDirection:"column"}}>

              <div style={{margin:"0 auto", width:"fit-content"}}>
                <p className="BigSizeText PoppinsBoldTextFont ElementToAnimateTyping" id='Section8HeaderText' style={{color:"#1D76AE"}}>Paket Layanan</p>
              </div>
              <p className="MidSizeText2 InterRegularTextFont" id='Section8MessageText' style={{color:"#667085", margin:"0 auto", textAlign:"center"}}>Kami membantu memasarkan penginapan Anda melalui berbagai saluran, dari media sosial hingga website. Dengan strategi komprehensif, visibilitas meningkat dan tamu lebih banyak! 📈🏨</p>
              
              <div className="PaketLayananContainer BasicShadow MidRadius" style={{margin:"0 auto"}}>
                <div className="PaketLayananSemiCircleContainer">
                  <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/ServicePageAssets/half-circle.png"} className="PaketLayananSemiCircle"/>
                  <p className="BiggerSizeText PoppinsExBoldTextFont" style={{width:"fit-content", height:"fit-content", color:"white", margin:"auto", zIndex: 1}}>#TERIMABERES</p>
                </div>

                <div className="BigPaddingWrapper RowGapBasic" style={{display:"flex", flexDirection:"column"}}>
                  <table className="PaketLayananTable">
                    <tr>
                      <td>
                        <div className="ColumnGapBasic" style={{display:"flex"}}>
                          <img className="BigSizeIcon" src={process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/circle-check-green.svg"}/>
                          <p className="MidSizeText PoppinsRegularTextFont" id='PaketLayananText1' style={{color:"white"}}>Manajemen penuh multi OTA</p>
                        </div>
                      </td>
                      <td>
                        <div className="ColumnGapBasic" style={{display:"flex"}}>
                          <img className="BigSizeIcon" src={process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/circle-check-green.svg"}/>
                          <p className="MidSizeText PoppinsRegularTextFont" id='PaketLayananText2' style={{color:"white"}}>Sinkronisasi kalender</p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div className="ColumnGapBasic" style={{display:"flex"}}>
                          <img className="BigSizeIcon" src={process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/circle-check-green.svg"}/>
                          <p className="MidSizeText PoppinsRegularTextFont" id='PaketLayananText3' style={{color:"white"}}>Optimasi konten berbasis storytelling</p>
                        </div>
                      </td>
                      <td>
                        <div className="ColumnGapBasic" style={{display:"flex"}}>
                          <img className="BigSizeIcon" src={process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/circle-check-green.svg"}/>
                          <p className="MidSizeText PoppinsRegularTextFont" id='PaketLayananText4' style={{color:"white"}}>Monitoring & optimasi 1 bulan</p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div className="ColumnGapBasic" style={{display:"flex"}}>
                          <img className="BigSizeIcon" src={process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/circle-check-green.svg"}/>
                          <p className="MidSizeText PoppinsRegularTextFont" id='PaketLayananText5' style={{color:"white"}}>Strategi harga weekday & weekend</p>
                        </div>
                      </td>
                      <td>
                        <div className="ColumnGapBasic" style={{display:"flex"}}>
                          <img className="BigSizeIcon" src={process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/circle-check-green.svg"}/>
                          <p className="MidSizeText PoppinsRegularTextFont" id='PaketLayananText6' style={{color:"white"}}>Earning Calculator</p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div className="ColumnGapBasic" style={{display:"flex"}}>
                          <img className="BigSizeIcon" src={process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/circle-check-green.svg"}/>
                          <p className="MidSizeText PoppinsRegularTextFont" id='PaketLayananText7' style={{color:"white"}}>Minim risiko overbooking</p>
                        </div>
                      </td>
                      <td>
                        <div className="ColumnGapBasic" style={{display:"flex"}}>
                          <img className="BigSizeIcon" src={process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/circle-check-green.svg"}/>
                          <p className="MidSizeText PoppinsRegularTextFont" id='PaketLayananText8' style={{color:"white"}}>Laporan & insight berkala</p>
                        </div>
                      </td>
                    </tr>
                  </table>
                  <div className="PaketLayananRPContainer MidRadius OrangeThickerLineButton Selectable" style={{margin:"0 auto"}}>
                    <p className="LessBigSizeText InterExBoldTextFont" style={{color:"black", margin:"auto"}}>RP 0</p>
                  </div>
                  <p className="LessBigSizeText InterExBoldTextFont" id='GratisBiayaSetupText' style={{color:"white", margin:"0 auto"}}>GRATIS BIAYA SETUP!</p>
                  <div className="BasicPaddingWrapper MidRadius" style={{backgroundColor:"white"}}>
                    <p className="MidSizeText3 PoppinsRegularTextFont" id='BiayaLayananMessageText' style={{color:"#ED7C42", textAlign:"center", margin:"auto"}}>Biaya layanan <span className="PoppinsBoldTextFont">2,5%</span> per transaksi di seluruh OTA dengan minimal kontrak 1 tahun bersama PinginGo.</p>
                  </div>
                </div>

              </div>

              <div className="PaketLayananAddOnsContainer BasicShadow MidRadius">
                <div className="OrangeHalfPaketLayananContainer">
                  <div className="OrangeHalfPaketLayanan"></div>
                  <p className="LessBigSizeText InterExBoldTextFont" id='Section8BAddOnsHeaderText' style={{color:"white", margin:"auto"}}>Add-Ons</p>
                </div>
                <div className="BigPaddingWrapper RowGapBasic" style={{flex:1, display:"flex", flexDirection:"column"}}>
                  <p className="LessBigSizeText PoppinsExBoldTextFont" id='Section8BHeaderText' style={{color:"#021B3A"}}>Website Property Express</p>
                  <table className="PaketLayananTable AutoFlexColumnOnSmaller">
                    <tr>
                      <td>
                        <div className="ColumnGapBasic" style={{display:"flex"}}>
                          <img className="BigSizeIcon" src={process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/circle-check-green.svg"}/>
                          <p className="MidSizeText2 PoppinsRegularTextFont" id='AddOnsText1' style={{color:"#021B3A"}}>Website properti kustom menggunakan 5 template yang clean & elegan</p>
                        </div>
                      </td>
                      <td>
                        <div className="ColumnGapBasic" style={{display:"flex"}}>
                          <img className="BigSizeIcon" src={process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/circle-check-green.svg"}/>
                          <p className="MidSizeText2 PoppinsRegularTextFont" id='AddOnsText2' style={{color:"#021B3A"}}>Halaman informasi properti (kamar, fasilitas, lokasi, galeri)</p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div className="ColumnGapBasic" style={{display:"flex"}}>
                          <img className="BigSizeIcon" src={process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/circle-check-green.svg"}/>
                          <p className="MidSizeText2 PoppinsRegularTextFont" id='AddOnsText3' style={{color:"#021B3A"}}>Desain mobile-friendly & responsif</p>
                        </div>
                      </td>
                      <td>
                        <div className="ColumnGapBasic" style={{display:"flex"}}>
                          <img className="BigSizeIcon" src={process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/circle-check-green.svg"}/>
                          <p className="MidSizeText2 PoppinsRegularTextFont" id='AddOnsText4' style={{color:"#021B3A"}}>Integrasi direct booking</p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div className="ColumnGapBasic" style={{display:"flex"}}>
                          <img className="BigSizeIcon" src={process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/circle-check-green.svg"}/>
                          <p className="MidSizeText2 PoppinsRegularTextFont" id='AddOnsText5' style={{color:"#021B3A"}}>Struktur dasar SEO-ready</p>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Section 9 ------------------------------------ */}
        <div className="TopBottomIndexSection ServiceSection9Con BottomIndexSection PlayableOnScroll">
            <div className="TopBottomIndexSection">
                <div className='SpecialWrapperExtraPage' style={{display: 'flex', flexDirection: 'column', zIndex: 1}}>
                    <div className="ExpandingCircleOrangeContainer">
                        <div className="ExpandingCircleOrange" />
                        <div className="ExpandingCircleOrangeAnimate"/>
                    </div>
                    <div className='ExtraPageSpecialPartVerticalAddOn'>
                        <div className='WhiteContentWrapperPadding MidRadius ColumnGapBasic2' style={{margin: 'auto', backgroundColor: 'rgba(0,0,0,0.7)'}}>
                            <p className="MidSizeText InterBoldTextFont" id='Section9HeaderText' style={{color: "white"}}>Siap meningkatkan performa listing Anda?</p>
                            <button className='BigUIButton OrangeButton BasicRadius Selectable'>
                              <p className='InterMediumTextFont ShowOnMobile' id='Section9ButtonTextMobile'>Jadwalkan Audit</p>
                              <p className='InterMediumTextFont HideOnMobile' id='Section9ButtonText'>Jadwalkan Audit Gratis 15 Menit Sekarang</p>
                            </button>
                        </div>
                    </div>
                </div>
                {/* <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/blue-circle-ayo-bergabung.svg" className="BlueCircleEdge"/> */}
                <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/ServicePageAssets/bg_footer.jpg"} className="BGHouseFooter"/>
            </div>
        </div>
      </div>
      <FooterExtraPage/>
    </div>
  )
}

export default Home